import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { ToggleHideAndShowResult } from '../../rope-shovel/pages/report-builder/report-builder-models';
import { TrainingService } from '../training.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-training-category',
  templateUrl: './add-training-category.component.html',
  styleUrls: ['./add-training-category.component.scss']
})
export class AddTrainingCategoryComponent implements OnInit {
  isSection: boolean = false;
  categoryName: string;
  maincategoryName:string;
  categoryDesc: string;
  maincategoryDesc: string;

  isCategoery: boolean = false;
  isMainCategoery:boolean=false;
  isCategoeryEdit: boolean = false;
  isMainCategoeryEdit:boolean=false;
  optionupdate: boolean = false;
  isParent: boolean = false;
  Name: string;
  sectionName: string;
  isUpdateCat: number = 0;
  sectionId: number;
  parentCatId: number;
  MainparentCatId:number;
  isTraining: boolean = false;
  trainingName: string;
  isTrainingEdit:boolean=false;
  isTrainingSection:boolean=false;
  trainingSectionName:string;
  isSubTrainingEdit:boolean=false;
  constructor(
    public _dialogRef: MatDialogRef<AddTrainingCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _notify: NotificationsService,
    private _trainingService: TrainingService,
    private ref: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    console.log("this.data", this.data)
    this.isCategoery = this.data.isCategoery;
    this.isMainCategoery = this.data.isMainCategoery;

    this.isUpdateCat = this.data.isUpdateCat;
    this.sectionId = this.data.sectionId;
    this.parentCatId = this.data.parentCatId;
    this.isTrainingEdit = this.data.isTrainingEdit;
    this.isTrainingSection = this.data.isTrainingSection;
    this.isSubTrainingEdit=this.data.isSubTrainingEdit;
    //edit section or cat
    this.isParent = this.data.isParent;
    this.Name = this.data.Name;
    this.isSection = this.data.isSection;
    this.isTraining = this.data.isTraining;
    this.isCategoeryEdit = this.data.isCategoeryEdit;
    this.isMainCategoeryEdit=this.data.isMainCategoeryEdit;
    this.MainparentCatId=this.data.MainparentCatId; 

    if (this.isParent)
      this.categoryName = this.Name;
    else
      this.sectionName = this.Name;
  }

  onAddMainCategory() {
    this._trainingService.AddNewMaincategory(this.maincategoryName, this.maincategoryDesc).subscribe(res => {
      if (res == true) {
        this._notify.success('Saved', 'Successfully added new main Category');
        this._dialogRef.close(true)
      } else {
        this._notify.error('Failed', 'Failed to save category');
      }
    })
  }

  
  onEditMiancategory() {
    this._trainingService.EditMaincategory(this.sectionId, this.Name).subscribe(res => {
      if (res == true) {
        this._notify.success('Saved', 'Successfully Update');
        this._dialogRef.close(true)
      } else {
        this._notify.error('Failed', 'Failed to Update');
      }
    })
  }
  onAddCategory() {
    this._trainingService.AddNewcategory(this.categoryName, this.categoryDesc,this.MainparentCatId).subscribe(res => {
      if (res == true) {
        this._notify.success('Saved', 'Successfully added new Category');
        this._dialogRef.close(true)
      } else {
        this._notify.error('Failed', 'Failed to save category');
      }
    })
  }

  onEditategory() {
    this._trainingService.EditcategoryOrSection(this.sectionId, this.Name).subscribe(res => {
      if (res == true) {
        this._notify.success('Saved', 'Successfully Update');
        this._dialogRef.close(true)
      } else {
        this._notify.error('Failed', 'Failed to Update');
      }
    })
  }

  onEditTraining(){
    this._trainingService.EditTraining(this.sectionId, this.Name).subscribe(res => {
      if (res == true) {
        this._notify.success('Saved', 'Successfully Update');
        this._dialogRef.close(true)
      } else {
        this._notify.error('Failed', 'Failed to Update');
      }
    })
  }

  onEditSubTraining(){
    this._trainingService.EditTrainingSection(this.sectionId, this.Name).subscribe(res => {
      if (res == true) {
        this._notify.success('Saved', 'Successfully Update');
        this._dialogRef.close(true)
      } else {
        this._notify.error('Failed', 'Failed to Update');
      }
    })
  }
  onAddSection() {
    this._trainingService.AddNewSection(this.parentCatId, this.sectionName).subscribe(res => {
      if (res == true) {
        this._notify.success('Saved', 'Successfully Saved Section');
        this._dialogRef.close(true)
      } else {
        this._notify.error('Failed', 'Failed to save section');
      }
    })
  }

  onAddTraining() {
    this._trainingService.AddNewTraining(this.parentCatId, this.trainingName).subscribe(res => {
      if (res == true) {
        this._notify.success('Saved', 'Successfully Saved Training');
        this._dialogRef.close(true)
      } else {
        this._notify.error('Failed', 'Failed to save training');
      }
    })
  }

  onAddTrainingSection(){
    this._trainingService.AddNewTrainingSection(this.parentCatId, this.trainingSectionName).subscribe(res => {
      if (res == true) {
        this._notify.success('Saved', 'Successfully Saved Training Section');
        this._dialogRef.close(true)
      } else {
        this._notify.error('Failed', 'Failed to save training section');
      }
    })
  }
  onNoClick() {
    this.optionupdate = false;
    this._dialogRef.close(false);
  }



}
